import { useTrackingDatas } from "@/hooks";
import { useTrackingSite } from "@/contexts/cdpConfig";
import { getUrlPath } from "@/utils";
import { featureFlagsTracking } from "@/contexts/CdpProvider";
import { useTracking } from "@/contexts/classified";
// TODO !!
// @ts-ignore
export const useTrackingViewMap = () => {
    var _a, _b, _c, _d;
    return (Object.assign(Object.assign({ av_pagetitle: "classified_detail_map" }, useTrackingDatas()), { av_platform: "web", av_url_path: getUrlPath(), av_site: useTrackingSite(), av_ab_test_variant: featureFlagsTracking, av_client_id: (_c = (_b = (_a = useTracking()) === null || _a === void 0 ? void 0 : _a.av_items) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.client_id, av_client_type: (_d = useTracking()) === null || _d === void 0 ? void 0 : _d.av_client_type }));
};
